import { Reveal } from "./anim";

const STEPS = [
  { n: "01", title: "Discover", body: "We audit your systems and understand the business behind the code." },
  { n: "02", title: "Design", body: "A clear architecture and roadmap, priced and scoped with no surprises." },
  { n: "03", title: "Deliver", body: "We build, deploy and integrate — shipping in tight, visible increments." },
  { n: "04", title: "Sustain", body: "Ongoing monitoring, support and iteration so nothing ever stalls." },
];

export default function Approach() {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#0A0A0B] border-t border-white/10 py-24 md:py-32 px-6 md:px-10"
    >
      <div className="mx-auto max-w-[1600px]">
        <Reveal as="p" className="font-mono text-xs uppercase tracking-[0.25em] text-accent mb-6">
          [ 04 ] — How we work
        </Reveal>
        <Reveal delay={0.1} as="h2" className="font-heading font-light uppercase tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[0.95] mb-16 md:mb-24 max-w-3xl">
          A process built for <span className="text-accent">momentum.</span>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {STEPS.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 0.1}
              className="group bg-[#0A0A0B] p-8 md:p-10 min-h-[280px] flex flex-col justify-between hover:bg-surface transition-colors duration-500"
            >
              <div className="font-mono text-6xl md:text-7xl font-black text-white/5 group-hover:text-accent/20 transition-colors duration-500">
                {s.n}
              </div>
              <div>
                <h3 className="font-heading text-2xl md:text-3xl font-medium tracking-tight mb-3">{s.title}</h3>
                <p className="text-sm text-[#A1A1AA] leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
